import { ReactNode } from 'react';

const SectionSubtitle = ({ children }: { children: ReactNode }) => (
	<h3 style={{ fontSize: '18px', fontWeight: 400, lineHeight: '32px', margin: 0 }}>{children}</h3>
);

export default SectionSubtitle;
